import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TMSharedUIModule } from '@com-delta-idp/mnx-trip-management-shared-ui';

@NgModule({
  imports: [CommonModule, TMSharedUIModule]
})
export class NavigationSmartModule {}
